import {combineReducers} from "redux";

import listeCoursReducer from "./listeCours";
import coursReducer from "./cours";

import listeRessourcesReducer from "./listeRessources";
import ressourceReducer from "./ressource";
import noteReducer from "./notes";


export default combineReducers({
    listeCours : listeCoursReducer,
    cours : coursReducer,
    listeRessources : listeRessourcesReducer,
    ressource: ressourceReducer,
    notes: noteReducer
});